import { createFileRoute } from '@tanstack/react-router';
import { requireCanManageUsers } from '@/features/auth/session/guards';
import { TasksPage } from '@/features/task/list-page';

export const Route = createFileRoute('/_authenticated/system/tasks')({
  beforeLoad: ({ context, location }) =>
    requireCanManageUsers(context.queryClient, location.href),
  component: TasksPage,
});
